import queryString from "query-string";
import md5 from "md5";
import { mapState, mapActions, mapGetters } from "vuex";
import { DATE_FORMAT, TIME_FORMAT } from "../mdsir/const";
import { moneyAmount } from "../mdsir/MdsirUtils";

export default {
  data: function() {
    return {
      reject: null,
      advanceSearchFilters: {
        date: new Date().toISOString().substr(0, 10),
        date2: new Date().toISOString().substr(0, 10),
      },
      authToken: "",
      requiredRules: [(v) => !!v || "Field is required"],
      emailRules: [
        (v) => {
          if (v) {
            return /.+@.+/.test(v) || "E-mail must be valid";
          }
          return true;
        },
      ],
      passwordLengthRules: [
        (v) =>
          (v && v.length <= 10 && v.length >= 6) ||
          `Password must be 6 to 10 characters`,
      ],
      currentPasswordRules: [
        (v) =>
          (this.logged && md5(v) === this.logged.user.password) ||
          `Current password did not matched.`,
      ],
      // paymentMethods: [
      //   {
      //     id: "cash",
      //     title: "Cash on delivery",
      //     logo_url: require("@/assets/img/payment_mathods/cash.png"),
      //   },
      //   {
      //     id: "nexus",
      //     title: "DBBL Nexus Card",
      //     logo_url: require("@/assets/img/payment_mathods/nexus.png"),
      //   },
      //   {
      //     id: "bkash",
      //     title: "bKash",
      //     logo_url: require("@/assets/img/payment_mathods/bkash.png"),
      //   },
      //   {
      //     id: "visa",
      //     title: "VISA Card",
      //     logo_url: require("@/assets/img/payment_mathods/visa.png"),
      //   },
      //   {
      //     id: "master",
      //     title: "Master Card",
      //     logo_url: require("@/assets/img/payment_mathods/master.png"),
      //   },
      // ],
    };
  },
  // data: () => ({
  //     resolve: null,
  //     reject: null
  // }),

  methods: {
    ...mapActions("common", ["showLoginModal", "isLoggedIn"]),
    toFormData(obj) {
      return queryString.stringify(obj);
      // var fd = new FormData();
      // for (var key in obj) {
      //     fd.append(key, obj[key]);
      // }
      // return fd;
    },
    clearData(obj) {
      var cleanedObj = {};
      for (var key in obj) {
        cleanedObj[key] = "";
      }
      return cleanedObj;
    },
    snackbarShow(text, color) {
      var errorText = text;
      if (typeof text == "object") {
        errorText = text.message || "";
        var errors = text.errors || {};
        color = text.success ? "success" : "error";
        for (var key in errors) {
          errorText += errors[key] + "\n";
        }
      }

      this.$store.commit("common/snackbarShow", true);
      this.$store.commit("common/snackbarText", errorText);
      this.$store.commit("common/snackbarColor", color);
    },

    editInlineAPI(editedItem, table, tableColumn) {
      this.$http
        .put("/inline_edit", {
          id: editedItem.id,
          item_name: table,
          [tableColumn]: editedItem[tableColumn],
        })
        .then((res) => {
          if (res.data.success) {
            this.getDataFromApi();
          }
          this.snackbarShow(res.data);
        });
    },
    post(uri, data) {
      return this.$http.post(uri, this.toFormData(data));
    },
    put(uri, data) {
      return this.$http.put(uri, this.toFormData(data));
    },
    get(uri, data) {
      return this.$http.get(uri, {
        params: data,
      });
    },
    getUpload(ofID, ofName, isSingale) {
      let params = { of_id: ofID, of_name: ofName };
      if (isSingale) {
        params.single = "yes";
      }
      return this.get("/upload", params);
    },
    deleteUpload(fileID) {
      return this.$http.delete(`/upload/${fileID}`);
    },
    getMyDate(format = null, dateString = null, dateStringFormat = null) {
      let reDate = this.$moment().format(format);
      if (dateString && dateStringFormat) {
        reDate = this.$moment(dateString, dateStringFormat).format(format);
      } else if (dateString) {
        reDate = this.$moment(dateString).format(format);
      }
      return reDate;
    },
    getDefaultDate(dateString = null) {
      return this.getMyDate(DATE_FORMAT, dateString);
    },
    getDefaultDateTime(dateString = null) {
      return this.getMyDate(DATE_FORMAT + ' ' + TIME_FORMAT , dateString);
    },
    getDefaultTime(timeString = null) {
      return this.getMyDate("hh:mm a", timeString, "HH:mm:ss");
    },
    getUploadURL(fileName) {
      return fileName ? `${this.$API_SERVER}/mdsir_uploads/${fileName}` : "";
    },
    // isBreakpoint() {
    //     const { xs, sm, width } = this.$vuetify.breakpoint;
    //     return xs || sm ? HeaderMobile : Header;
    // }
    advanceSearchModalShow() {
        // console.log('onApply assign: ', onAply);
        // this.onAdvanceSearchApply = onAply;
      this.$router.push({
        // name: this.$route.name,
        // params: {
        //   calendar_date_id: this.$router.currentRoute.params.calendar_date_id,
        //   tab: tab.route,
        // },
        query: {
          ...this.$route.query,
          modal: "adv_search",
        },
      });
    },
    advanceSearchApply() {
        // console.log('apply: ', this.onAdvanceSearchApply);
        // this[this.onAdvanceSearchApply]();
        this.onAdvanceSearchApply();
    },
    modalClose() {
      this.$router.push({
        // name: this.$route.name,
        // params: {
        //   calendar_date_id: this.$router.currentRoute.params.calendar_date_id,
        //   tab: tab.route,
        // },
        query: {
          ...this.$route.query,
          modal: undefined,
        },
      });
    },
    mA(amount){
      return moneyAmount(amount);
    }
  },

  computed: {
    ...mapGetters("common", {
      logged: "logged",
      settings: "settings",
    }),
    // isSnackbarShow() {
    //     return this.$store.getters.snackbarShow;
    // }
    isdvanceSearchModal() {
      return this.$route.query.modal === "adv_search" ? true : false;
    },
  },

  watch: {
    logged: function(n) {
      this.authToken = "Bearer " + n.token;
      this.$http.defaults.headers.common["authorization"] = this.authToken;
    },
    $route(to, from) {
      document.title =
      this.$ENV.VUE_APP_TITLE_SHORT + ' - ' + this.$ENV.VUE_APP_TITLE +
        (to.meta.title ? " | " + to.meta.title : "");
    },
  },

  created: function() {
    this.authToken =
      this.logged && this.logged.token ? "Bearer " + this.logged.token : "";
    this.$http.defaults.headers.common["authorization"] = this.authToken;
  },
};
